if (!customElements.get('ayksl-hsm-filter-ajax')) {
  class AykslHsmFilterAjax extends HTMLElement {
    constructor() {
      super();
      this.childSelect = this.querySelector('custom-select[data-level="2"]');
      this.grandchildSelect = this.querySelector('custom-select[data-level="3"]');
      this.submitButton = this.querySelector('.js-submit');
      this.priceRange = this.querySelector('.js-quick-nav-price');
      this.action = this.dataset.action || 'navigate';
      this.baseUrl = this.dataset.baseUrl || window.location.pathname;
      this.sortParam = this.dataset.filterSort || '';
      this.autoApply = this.dataset.autoApply === 'true';
      this.hideSubmit = this.dataset.hideSubmit === 'true';
      this.showPrice = this.dataset.showPrice === 'true';
      this.sectionTargets = AykslHsmFilterAjax.parseList(this.dataset.sections);
      this.sectionSelectors = AykslHsmFilterAjax.parseList(this.dataset.sectionSelectors);
      this.filterState = {};
      this.priceFilters = { min: '', max: '' };
      this.pendingController = null;
      this.lastRenderedUrl = null;
      this.sectionKeyOverrides = new Map();

      if (!this.sectionTargets.length) {
        const detected = this.detectCollectionSections();
        if (detected.length) {
          this.sectionTargets = detected;
          this.dataset.sections = detected.join(',');
        }
      }

      if (this.hideSubmit && this.submitButton) {
        this.submitButton.setAttribute('hidden', 'hidden');
      }

      this.addEventListener('change', this.handleChange.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
    }

    static parseList(value) {
      if (!value) return [];
      return value
        .split(/[\n,]/)
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);
    }

    handleClick(evt) {
      const slideshowElem = this.closest('slide-show');
      if (slideshowElem && slideshowElem.dataset.autoplay === 'true') {
        const autoplayBtn = slideshowElem.querySelector('.autoplay-btn');
        if (autoplayBtn) autoplayBtn.click();
      }

      if (evt.target.closest('.js-submit') && this.action === 'filter') {
        evt.preventDefault();
        if (!this.autoApply) this.applyFilters();
      }
    }

    handleChange(evt) {
      if (evt.target.matches('custom-select')) {
        const selectedOption = evt.target.querySelector('[aria-selected="true"]');
        const hasSelectedValue =
          evt.detail && Object.prototype.hasOwnProperty.call(evt.detail, 'selectedValue');
        const selectedValue = hasSelectedValue ? evt.detail.selectedValue : '';

        if (this.action === 'filter') {
          this.applyFilterSelection(evt.target, selectedOption, selectedValue);
        } else if (selectedValue) {
          this.url = selectedOption.dataset.url;
          this.updateSubmitButton(this.url);
          if (selectedOption.dataset.isCollection) {
            this.parseCollectionInfo(this.url);
          } else {
            this.unparseCollectionInfo();
          }
        } else {
          this.updateSubmitButton('#');
          this.unparseCollectionInfo();
        }

        if (selectedValue) {
          if (evt.target.dataset.level === '1' && this.childSelect) {
            AykslHsmFilterAjax.prepareSelect(this.childSelect, selectedValue);
            this.resetSelectWithFilters(this.grandchildSelect, true);
          } else if (evt.target.dataset.level === '2' && this.grandchildSelect) {
            AykslHsmFilterAjax.prepareSelect(this.grandchildSelect, selectedValue);
          }
        } else {
          if (evt.target.dataset.level === '1') {
            this.resetSelectWithFilters(this.childSelect, true);
            this.resetSelectWithFilters(this.grandchildSelect, true);
          } else if (evt.target.dataset.level === '2') {
            this.resetSelectWithFilters(this.grandchildSelect, true);
          }
        }

        if (this.action === 'filter') {
          this.refreshFilterState(evt.target);
        }
      } else if (evt.target.closest('.price-range')) {
        if (!this.priceRange) return;
        const priceRangeMin = this.priceRange.querySelector("[name='filter.v.price.gte']").value;
        const priceRangeMax = this.priceRange.querySelector("[name='filter.v.price.lte']").value;

        if (this.action === 'filter') {
          this.priceFilters.min = priceRangeMin || '';
          this.priceFilters.max = priceRangeMax || '';
          this.refreshFilterState();
        } else {
          let url = this.url; // eslint-disable-line
          if (priceRangeMin) {
            url = url.includes('?') ? `${url}&` : `${url}?`;
            url += `filter.v.price.gte=${priceRangeMin}`;
          }
          if (priceRangeMax) {
            url = url.includes('?') ? `${url}&` : `${url}?`;
            url += `filter.v.price.lte=${priceRangeMax}`;
          }
          this.updateSubmitButton(url);
          this.parseCollectionInfo(url);
        }
      } else {
        AykslHsmFilterAjax.resetSelect(evt.target, false);
      }
    }

    applyFilterSelection(selectElem, option, selectedValue) {
      if (this.action !== 'filter' || !selectElem) return;

      const filterParam = selectElem.dataset.filterParam;
      if (!filterParam) return;

      let filterValue = '';
      if (option && option.dataset.filterValue) {
        filterValue = option.dataset.filterValue;
      } else if (selectedValue !== undefined && selectedValue !== null) {
        filterValue = String(selectedValue).trim();
      } else if (option) {
        filterValue = option.textContent.trim();
      }

      if (filterValue) {
        this.filterState[filterParam] = filterValue;
      } else {
        delete this.filterState[filterParam];
      }
    }

    refreshFilterState(triggerSelect) {
      if (this.action !== 'filter') return;

      this.url = this.buildFilterUrl();

      this.updateSubmitButton(this.url);

      if (this.shouldAutoApply(triggerSelect)) {
        this.applyFilters();
      } else {
        if (!this.autoApply) {
          if (this.hasActiveFilters() && this.url) {
            this.parseCollectionInfo(this.url);
          } else {
            this.unparseCollectionInfo();
          }
        } else if (!this.hasActiveFilters()) {
          this.unparseCollectionInfo();
        }
      }
    }

    async applyFilters() {
      const url = this.url || this.buildFilterUrl();
      if (!url) return;

      if (!this.sectionTargets.length) {
        window.location.assign(url);
        return;
      }

      if (url === this.lastRenderedUrl && !this.hasActiveFilters()) {
        history.replaceState({}, '', url);
        this.updateButtonFromDom();
        return;
      }

      this.abortPendingRequest();
      this.setLoading(true);

      const controller = new AbortController();
      this.pendingController = controller;

      const fetchUrl = new URL(url, window.location.origin);
      const currentUrl = new URL(window.location.href);

      ['section_id', 'preview_theme_id', '_fd', 'pb'].forEach((param) => {
        if (!fetchUrl.searchParams.has(param) && currentUrl.searchParams.has(param)) {
          const value = currentUrl.searchParams.get(param);
          if (value) fetchUrl.searchParams.set(param, value);
        }
      });

      fetchUrl.searchParams.set('sections', this.sectionTargets.join(','));

      try {
        const response = await fetch(fetchUrl.toString(), {
          signal: controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) throw new Error('Sections request failed');
        const payloadText = await response.text();
        let payload;

        try {
          payload = payloadText ? JSON.parse(payloadText) : null;
        } catch (parseErr) {
          payload = payloadText;
        }

        const sectionHtmlMap = AykslHsmFilterAjax.normalizeSectionPayload(
          payload,
          this.sectionTargets
        );

        if (!sectionHtmlMap) throw new Error('Invalid sections payload');

        this.renderSections(sectionHtmlMap);
        this.updateButtonFromDom();
        this.updatePriceRangeFromData(sectionHtmlMap);
        this.lastRenderedUrl = url;
        history.replaceState({}, '', url);
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('AYKSL filter: sections fetch failed, falling back to full reload.', err);
        window.location.assign(url);
      } finally {
        if (this.pendingController === controller) {
          this.pendingController = null;
        }
        this.setLoading(false);
      }
    }

    abortPendingRequest() {
      if (this.pendingController) {
        this.pendingController.abort();
        this.pendingController = null;
      }
    }

    setLoading(state) {
      this.classList.toggle('is-loading', state);
      this.setAttribute('aria-busy', state ? 'true' : 'false');

      this.sectionTargets.forEach((sectionId, index) => {
        const container = this.getSectionContainer(sectionId, index);
        if (container) container.classList.toggle('is-loading', state);
      });

      if (this.submitButton && !this.hideSubmit) {
        if (state) {
          this.submitButton.classList.add('is-loading');
          this.submitButton.setAttribute('aria-disabled', 'true');
        } else {
          this.submitButton.classList.remove('is-loading');
        }
      }
    }

    renderSections(sectionHtmlMap) {
      if (!sectionHtmlMap) return;

      this.sectionTargets.forEach((sectionId, index) => {
        const resolvedKey = this.resolveSectionKey(sectionId, sectionHtmlMap);
        const html = resolvedKey ? sectionHtmlMap[resolvedKey] : null;
        if (!html) return;

        const container = this.getSectionContainer(sectionId, index, resolvedKey);
        if (!container) return;

        container.innerHTML = html;
        document.dispatchEvent(
          new CustomEvent('shopify:section:load', { detail: { sectionId } })
        );
      });
    }

    getSectionContainer(sectionId, index, resolvedKey) {
      const selector = this.sectionSelectors[index];
      if (selector) {
        const container = document.querySelector(selector);
        if (container) return container;
      }

      const candidates = [];
      if (resolvedKey) candidates.push(`shopify-section-${resolvedKey}`);
      candidates.push(`shopify-section-${sectionId}`);

      for (const id of candidates) {
        const container = document.getElementById(id);
        if (container) return container;
      }

      const dataCandidates = [];
      if (resolvedKey) dataCandidates.push(resolvedKey);
      dataCandidates.push(sectionId);

      for (const id of dataCandidates) {
        const exact = document.querySelector(`[data-section-id="${id}"]`);
        if (exact) return exact;

        const suffixMatch = this.findSectionBySuffix(id);
        if (suffixMatch) return suffixMatch;
      }

      return null;
    }

    updateButtonFromDom() {
      if (!this.submitButton || this.hideSubmit) return;

      let numResults = null;
      this.sectionTargets.some((sectionId, index) => {
        const container = this.getSectionContainer(sectionId, index, this.resolveSectionKey(sectionId));
        if (!container) return false;
        const resultsElem = container.querySelector('[data-num-results]');
        if (resultsElem) {
          numResults = parseInt(resultsElem.dataset.numResults || '0', 10);
          return true;
        }
        return false;
      });

      if (numResults === null || Number.isNaN(numResults)) return;

      if (numResults === 0) {
        this.submitButton.textContent = theme.strings.quickNav.show_products_none;
        this.submitButton.setAttribute('aria-disabled', 'true');
      } else if (numResults === 1) {
        this.submitButton.textContent = theme.strings.quickNav.button_one.replace(
          '[quantity]',
          numResults
        );
        this.submitButton.removeAttribute('aria-disabled');
      } else {
        this.submitButton.textContent = theme.strings.quickNav.button_other.replace(
          '[quantity]',
          numResults
        );
        this.submitButton.removeAttribute('aria-disabled');
      }
    }

    updatePriceRangeFromData(sectionHtmlMap) {
      if (!this.showPrice || !this.priceRange) return;

      const htmlStrings = this.sectionTargets
        .map((sectionId) => {
          const resolvedKey = this.resolveSectionKey(sectionId, sectionHtmlMap);
          return resolvedKey ? sectionHtmlMap[resolvedKey] : null;
        })
        .filter(Boolean);

      let priceRangeFound = false;
      htmlStrings.some((html) => {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;
        const priceRangeElem = tmpl.content.querySelector('price-range');
        if (priceRangeElem) {
          this.priceRange.innerHTML = priceRangeElem.outerHTML;
          const maxHeight = this.priceRange.querySelector('.price-range')?.clientHeight;
          if (maxHeight) {
            this.priceRange.style.maxHeight = `${parseInt(maxHeight, 10) + 1}px`;
          }
          priceRangeFound = true;
          return true;
        }
        return false;
      });

      if (!priceRangeFound && this.url) {
        this.parseCollectionInfo(this.url);
      }
    }

    buildFilterUrl() {
      const base = this.baseUrl || window.location.pathname;
      const params = new URLSearchParams();
      let hasFilters = false;

      Object.entries(this.filterState).forEach(([param, value]) => {
        if (param && value) {
          params.append(param, value);
          hasFilters = true;
        }
      });

      if (this.priceFilters.min) {
        params.set('filter.v.price.gte', this.priceFilters.min);
        hasFilters = true;
      }

      if (this.priceFilters.max) {
        params.set('filter.v.price.lte', this.priceFilters.max);
        hasFilters = true;
      }

      if (this.sortParam) {
        this.sortParam.split('&').forEach((pair) => {
          const trimmed = pair.trim();
          if (!trimmed) return;
          const [key, ...rest] = trimmed.split('=');
          if (!key) return;
          params.append(key, rest.join('='));
        });
      }

      const query = params.toString();
      if (!query) return base;
      const separator = base.includes('?') ? '&' : '?';
      return `${base}${separator}${query}`;
    }

    hasActiveFilters() {
      const hasSelectFilters = Object.values(this.filterState).some(
        (val) => typeof val === 'string' && val.length > 0
      );
      const hasPriceFilters = Boolean(this.priceFilters.min || this.priceFilters.max);
      return hasSelectFilters || hasPriceFilters;
    }

    clearFilterForSelect(selectElem) {
      if (this.action !== 'filter' || !selectElem) return;
      const filterParam = selectElem.dataset.filterParam;
      if (filterParam) delete this.filterState[filterParam];
    }

    resetSelectWithFilters(selectElem, disable) {
      if (!selectElem) return;
      if (this.action === 'filter') this.clearFilterForSelect(selectElem);
      AykslHsmFilterAjax.resetSelect(selectElem, disable);
    }

    async parseCollectionInfo(url) {
      if (!url) return;

      const shouldUpdateButton = this.submitButton && !this.hideSubmit;
      if (shouldUpdateButton) {
        this.submitButton.ariaDisabled = 'true';
        this.submitButton.classList.add('is-loading');
      }
      let preventButtonEnable = false;

      const response = await fetch(url);
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        if (shouldUpdateButton) {
          const productsContainer = tmpl.content.querySelector('[data-num-results]');
          if (productsContainer) {
            const numResults = parseInt(productsContainer.dataset.numResults, 10);
            if (numResults === 0) {
              this.submitButton.textContent = theme.strings.quickNav.show_products_none;
              preventButtonEnable = true;
            } else if (numResults === 1) {
              this.submitButton.textContent = theme.strings.quickNav.button_one.replace(
                '[quantity]',
                numResults
              );
            } else {
              this.submitButton.textContent = theme.strings.quickNav.button_other.replace(
                '[quantity]',
                numResults
              );
            }
          } else {
            // eslint-disable-next-line
            console.warn(
              'Enterprise Theme: An element with [data-num-results] could not be found on the product page.',
              url
            );
          }
        }

        if (this.showPrice) {
          const priceRangeElem = tmpl.content.querySelector('price-range');
          if (priceRangeElem) {
            this.priceRange.innerHTML = priceRangeElem.outerHTML;
            const maxHeight = this.priceRange.querySelector('.price-range').clientHeight;
            this.priceRange.style.maxHeight = `${parseInt(maxHeight, 10) + 1}px`;
          } else {
            // eslint-disable-next-line
            console.warn(
              'Enterprise Theme: No price range slider could be found for collection.',
              url
            );
          }
        }
      }

      if (shouldUpdateButton) {
        if (!preventButtonEnable) this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('is-loading');
      }
    }

    unparseCollectionInfo() {
      if (this.priceRange) this.priceRange.style.maxHeight = '0px';
      if (this.submitButton && !this.hideSubmit) {
        this.submitButton.textContent = theme.strings.quickNav.button_standard;
      }
      if (this.action === 'filter') {
        this.priceFilters = { min: '', max: '' };
      }
    }

    updateSubmitButton(url) {
      if (!this.submitButton || this.hideSubmit) return;

      const isValidUrl = url && url.length > 0 && url !== '#';
      const filtersReady =
        this.action !== 'filter' ? isValidUrl : this.hasActiveFilters() && isValidUrl;

      if (filtersReady) {
        this.submitButton.href = url;
        this.submitButton.removeAttribute('aria-disabled');
      } else {
        this.submitButton.href = '#';
        this.submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    static prepareSelect(selectElem, value) {
      let hasOptions = false;
      let counter = 0;

      selectElem
        .querySelectorAll('.custom-select__option:not(.ayksl-hsm-filter__default-option)')
        .forEach((childLink) => {
          if (childLink.dataset.parentHandle === value) {
            hasOptions = true;
            childLink.style.display = '';
            counter += 1;
          } else {
            childLink.style.display = 'none';
          }
        });

      const listbox = selectElem.querySelector('.ayksl-hsm-filter__listbox');
      listbox.setAttribute('data-link-count', counter < 5 ? counter : 'loads');

      AykslHsmFilterAjax.resetSelect(selectElem, !hasOptions);

      if (hasOptions) {
        selectElem.querySelector('.custom-select__btn').removeAttribute('disabled');
      }
    }

    static resetSelect(selectElem, disable) {
      if (!selectElem) return;
      const listbox = selectElem.querySelector('.custom-select__listbox');
      if (listbox) listbox.removeAttribute('aria-activedescendant');

      const selectedOption = selectElem.querySelector('[aria-selected="true"]');
      if (selectedOption) {
        selectedOption.setAttribute('aria-selected', 'false');
      }

      const label = selectElem.querySelector('.custom-select__btn span');
      if (label) label.textContent = label.dataset.defaultText;
      if (disable) {
        const btn = selectElem.querySelector('.custom-select__btn');
        if (btn) btn.setAttribute('disabled', 'disabled');
      }

      if (typeof selectElem.init === 'function') {
        selectElem.init();
      }
    }

    static normalizeSectionPayload(payload, sectionIds) {
      if (!payload) return null;

      if (typeof payload === 'string') {
        if (sectionIds.length === 1) {
          return { [sectionIds[0]]: payload };
        }
        return null;
      }

      if (payload.sections && typeof payload.sections === 'object') {
        return payload.sections;
      }

      if (typeof payload === 'object') {
        return payload;
      }

      return null;
    }

    shouldAutoApply(triggerSelect) {
      if (!this.autoApply) return false;
      if (!triggerSelect) return true;

      const triggerLevel = parseInt(triggerSelect.dataset.level || '0', 10);
      if (Number.isNaN(triggerLevel)) return true;

      if (!this.hasEnabledSelectBeyond(triggerLevel)) return true;

      return false;
    }

    hasEnabledSelectBeyond(level) {
      return this.getFilterSelects().some((select) => {
        const selectLevel = parseInt(select.dataset.level || '0', 10);
        if (Number.isNaN(selectLevel) || selectLevel <= level) return false;
        const btn = select.querySelector('.custom-select__btn');
        return btn && !btn.hasAttribute('disabled');
      });
    }

    getFilterSelects() {
      if (!this._filterSelects) {
        this._filterSelects = Array.from(this.querySelectorAll('custom-select[data-filter-param]'));
      }
      return this._filterSelects;
    }

    resolveSectionKey(sectionId, sectionHtmlMap) {
      if (this.sectionKeyOverrides.has(sectionId)) {
        const cached = this.sectionKeyOverrides.get(sectionId);
        if (!sectionHtmlMap || (cached && sectionHtmlMap && cached in sectionHtmlMap)) {
          return cached;
        }
        this.sectionKeyOverrides.delete(sectionId);
      }

      if (!sectionHtmlMap) return sectionId;

      if (Object.prototype.hasOwnProperty.call(sectionHtmlMap, sectionId)) {
        this.sectionKeyOverrides.set(sectionId, sectionId);
        return sectionId;
      }

      const keys = Object.keys(sectionHtmlMap);
      const suffixMatches = keys.find((key) => key.endsWith(`__${sectionId}`) || key.endsWith(`-${sectionId}`));
      if (suffixMatches) {
        this.sectionKeyOverrides.set(sectionId, suffixMatches);
        return suffixMatches;
      }

      if (keys.length === 1) {
        this.sectionKeyOverrides.set(sectionId, keys[0]);
        return keys[0];
      }

      this.sectionKeyOverrides.set(sectionId, null);
      return null;
    }

    findSectionBySuffix(sectionId) {
      const suffix = `__${sectionId}`;
      const idSelector = `[id^="shopify-section-"][id$="${suffix}"]`;
      let container = document.querySelector(idSelector);
      if (container) return container;

      container = document.querySelector(`[data-section-id$="${suffix}"]`);
      if (container) return container;

      return null;
    }

    detectCollectionSections() {
      const results = new Set();
      const isCollectionPage =
        (document.body?.dataset?.template || '').includes('collection') ||
        window.location.pathname.includes('/collections/');
      if (!isCollectionPage) return [];

      const candidates = document.querySelectorAll(
        '[id^="shopify-section-"][id*="collection-products"], [data-section-id*="collection-products"]'
      );

      candidates.forEach((el) => {
        const dataId = el.dataset?.sectionId;
        const domId = el.id ? el.id.replace(/^shopify-section-/, '') : null;
        if (dataId && dataId.includes('collection-products')) results.add(dataId);
        if (domId && domId.includes('collection-products')) results.add(domId);
      });

      return Array.from(results);
    }
  }

  customElements.define('ayksl-hsm-filter-ajax', AykslHsmFilterAjax);
}
